<div class="form-overlay-wrapper player-common-component">

  <div class="content">

    <div class="title" *ngIf="formOverlay.form.title">{{formOverlay.form.title}}</div>
    <div class="description" *ngIf="formOverlay.form.description"><span [innerHTML]="formOverlay.form.description | linky:{stripPrefix:false}"></span></div>

    <form [formGroup]="formGroup">
      <!-- chromeのautocomplete対策 -->
      <input name="password" type="password" style="display:none;overflow:hidden;"><!-- password autocomplete対策 -->
      <div class="form-wrapper">
        <div class="form">
          <ul formArrayName="formPropertyKeys">
            <li *ngFor="let formPropertyKeysFormGroup of formPropertyKeysFormArray.controls; let i = index" formGroupName="{{i}}" [class]="formOverlay.form.formPropertyKeys[i]?.width" class="form-field">
              <div>
                <!-- 前説明文 -->
                <div class="before-text" *ngIf="formOverlay.form.formPropertyKeys[i]?.beforeText" [innerHTML]="formOverlay.form.formPropertyKeys[i]?.beforeText"></div>
                
                <ng-container [ngSwitch]="formOverlay.form.formPropertyKeys[i]?.inputType">
                  <ng-container *ngSwitchCase="FormPropertyKey.InputTypeText">
                    <mat-form-field appearance="outline">
                      <mat-label>{{formOverlay.form.formPropertyKeys[i]?.label}} <span *ngIf="formOverlay.form.formPropertyKeys[i]?.required == 1" class="required">*</span></mat-label>
                      <input matInput formControlName="value" type="text" autocomplete="off">
                      <mat-hint>
                        <ng-container *ngIf="formOverlay.form.formPropertyKeys[i]?.required == 1">必須、</ng-container>
                        {{FormPropertyKey.InputTypeTextMaxLength}}文字以内
                      </mat-hint>
                      <mat-error *ngIf="hasError(formPropertyKeyFormControl(i, 'value'), 'required')">必須項目です</mat-error>
                      <mat-error *ngIf="hasError(formPropertyKeyFormControl(i, 'value'), 'maxlength')">入力文字数が上限を超えています</mat-error>
                    </mat-form-field>
                  </ng-container>
                  <ng-container *ngSwitchCase="FormPropertyKey.InputTypeTextarea">
                    <mat-form-field appearance="outline">
                      <mat-label>{{formOverlay.form.formPropertyKeys[i]?.label}} <span *ngIf="formOverlay.form.formPropertyKeys[i]?.required == 1" class="required">*</span></mat-label>
                      <textarea matInput formControlName="value" autocomplete="off"></textarea>
                      <mat-hint>
                        <ng-container *ngIf="formOverlay.form.formPropertyKeys[i]?.required == 1">必須、</ng-container>
                        {{FormPropertyKey.InputTypeTextareaMaxLength}}文字以内
                      </mat-hint>
                      <mat-error *ngIf="hasError(formPropertyKeyFormControl(i, 'value'), 'required')">必須項目です</mat-error>
                    </mat-form-field>
                  </ng-container>
                  <ng-container *ngSwitchCase="FormPropertyKey.InputTypeEmail">
                    <mat-form-field appearance="outline">
                      <mat-label>{{formOverlay.form.formPropertyKeys[i]?.label}} <span *ngIf="formOverlay.form.formPropertyKeys[i]?.required == 1" class="required">*</span></mat-label>
                      <input matInput formControlName="value" type="text" autocomplete="off">
                      <mat-hint>
                        <ng-container *ngIf="formOverlay.form.formPropertyKeys[i]?.required == 1">必須</ng-container>
                      </mat-hint>
                      <mat-error *ngIf="hasError(formPropertyKeyFormControl(i, 'value'), 'required')">必須項目です</mat-error>
                      <mat-error *ngIf="hasError(formPropertyKeyFormControl(i, 'value'), 'email')">メールアドレスの書式が正しくありません</mat-error>
                    </mat-form-field>
                  </ng-container>
                  <ng-container *ngSwitchCase="FormPropertyKey.InputTypeSelectDropdown">
                    <mat-form-field appearance="outline">
                      <mat-label>{{formOverlay.form.formPropertyKeys[i]?.label}} <span *ngIf="formOverlay.form.formPropertyKeys[i]?.required == 1" class="required">*</span></mat-label>
                      <mat-select matNativeControl formControlName="value">
                        <mat-option *ngFor="let option of formOverlay.form.formPropertyKeys[i].options" [value]="option.value">{{option.label == null ? option.value : option.label}}</mat-option>
                      </mat-select>
                      <mat-hint>
                        <ng-container *ngIf="formOverlay.form.formPropertyKeys[i]?.required == 1">必須</ng-container>
                      </mat-hint>
                      <mat-error *ngIf="hasError(formPropertyKeyFormControl(i, 'value'), 'required')">必須項目です</mat-error>
                    </mat-form-field>
                  </ng-container>
                  <ng-container *ngSwitchCase="FormPropertyKey.InputTypeSingleCheckbox">
                    <div class="single-checkbox-field">
                      <mat-checkbox formControlName="value" color="primary">
                        <span *ngIf="formOverlay.form.formPropertyKeys[i]?.required == 1" class="required">*</span>
                        {{formOverlay.form.formPropertyKeys[i]?.label}}
                      </mat-checkbox>
                      <!-- <mat-error *ngIf="hasError(formPropertyKeyFormControl(i, 'value'), 'required')" class="checkbox-error">
                        必須項目です
                      </mat-error> -->
                    </div>
                  </ng-container>
                  <ng-container *ngSwitchCase="FormPropertyKey.InputTypeHidden">
                    <input formControlName="value" type="hidden">
                  </ng-container>
                </ng-container>
                
                <!-- 後説明文 -->
                <div class="after-text" *ngIf="formOverlay.form.formPropertyKeys[i]?.afterText" [innerHTML]="formOverlay.form.formPropertyKeys[i]?.afterText"></div>
              </div>
            </li>
          </ul>
        </div>
      </div>
      <div class="btn-wrapper">
        <div class="btn"></div>
        <div class="btn"><button mat-flat-button color="primary" [class.disabled]="formGroup.invalid" (click)="done()">{{formOverlay.form.sendBtnTitle}}</button></div>
        <div class="btn" [class.hidden]="formOverlay.form.withSkip != Form.WithSkipTrue"><button type="button" mat-button class="link" (click)="skip()">スキップ</button></div>
      </div>

    </form>

  </div>

</div>